// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HvIp","largestCol":"styles_largestCol__1AFCR","smallestCol":"styles_smallestCol__aopyl"};